import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'roleText',
})
export class RoleTextPipe implements PipeTransform {
    transform(value: string) {
        if (value == null || value === '') {
            return '';
        }

        switch (value) {
            case 'Developer':
                return 'Developer Access';
            case 'SystemAdmin':
                return 'District Administrator Access';
            case 'DistrictAdmin':
                return 'District Administrator Access';
            case 'DistrictUser':
                return 'District User Access';
            case 'CollegeAdmin':
                return 'College Administrator Access';
            case 'Advisor':
                return 'College Advisor Access';
            case 'CollegeSupport':
                return 'College Support Staff Access';
            case 'SchoolAdmin':
                return 'School Administrator Access';
            case 'Counselor':
                return 'School Counselor Access';
            case 'Student':
                return 'Student Access';
            case 'Parent':
                return 'Parent Access';

            default:
                return value;
        }
    }
}



// WEBPACK FOOTER //
// ./src/pipes/roletext.pipe.ts